import { Injectable, inject } from '@angular/core';
import { EmployeeService } from '@gen/employee/employee.service';

import { RealtimeSocketService } from './realtime-socket.service';

import { REALTIME_EVENT, type CleanerListInvalidationPayload } from '@/shared/realtime-events';


@Injectable({ providedIn: 'root' })
export class CleanerCacheRealtimeService {
  private readonly employeeService = inject(EmployeeService);
  private readonly realtimeSocketService = inject(RealtimeSocketService);
  private started = false;

  start(): void {
    if (this.started) {
      return;
    }

    this.started = true;
    this.realtimeSocketService.listen<CleanerListInvalidationPayload>(REALTIME_EVENT.CLEANER_LIST_INVALIDATED).subscribe({
      next: () => this.employeeService.clearCachedAllArray(),
      error: (error) => console.error('[CleanerCacheRealtimeService] Failed to receive cleaner cache invalidation updates.', error)
    });
    this.realtimeSocketService.listen<void>('connect').subscribe({
      next: () => this.employeeService.clearCachedAllArray(),
      error: (error) => console.error('[CleanerCacheRealtimeService] Failed to observe realtime reconnects.', error)
    });
  }
}
